import domain from './domain';

/**
 * 开发环境
 */
// const dev = {
//   //cookie顶域
//   DOMAIN: window.location.hostname,
//   //api
//   API_V2_URL: "https://hitpaw-test-api.afirstsoft.cn/api/v2/",
// };

/**
 * 测试环境
 */
const test = {
  //cookie顶域
  DOMAIN: window.location.hostname,
  //api
  API_V2_URL: 'https://hitpaw-test-api.afirstsoft.cn/api/v2/',
  googleUrl: 'https://account-test-api.afirstsoft.cn/api/v1/auth/google-oauth',
};

/**
 * 生产环境
 */
const prod = {
  //cookie顶域
  DOMAIN: domain,
  //api
  API_V2_URL: 'https://api.hitpaw.com/api/v2/',
  googleUrl: 'https://account.afirstsoft.com/api/v1/auth/google-oauth',
};

/**
 * 开发和测试环境
 */
const dev = {
  //cookie顶域
  DOMAIN: window.location.hostname,
  //api
  API_V2_URL: 'https://hitpaw-test-api.afirstsoft.cn/api/v2/',
  googleUrl: 'https://account-test-api.afirstsoft.cn/api/v1/auth/google-oauth',
};

console.log('process.env.NODE_ENV', process.env.NODE_ENV);

// 新增dev环境配置
let envConfig;
if (process.env.NODE_ENV === 'development') {
  envConfig = dev;
} else {
  envConfig = prod;
}

/*
dockerdev
dockertest
dockerprod
dockerstage
dockeruat

hitpaw-dev-api.afirstsoft.cn  容器开发环境
hitpaw-test-api-docker.afirstsoft.cn   容器测试环境
*/
console.log(
  'REACT_APP_BUILD_ENV_DOCKER',
  process.env.REACT_APP_BUILD_ENV_DOCKER
);
let ENVdocker = process.env.REACT_APP_BUILD_ENV_DOCKER;
if (ENVdocker === 'dockerdev') {
  let dockerdev = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-dev-api.afirstsoft.cn/api/v2/',
  };
  envConfig = dockerdev;
}
if (ENVdocker === 'dockertest') {
  let dockertest = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-test-api-docker.afirstsoft.cn/api/v2/',
  };
  envConfig = dockertest;
}
if (ENVdocker === 'dockerstage') {
  let dockerstage = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-stage-api.afirstsoft.cn/api/v2/',
  };
  envConfig = dockerstage;
}
if (ENVdocker === 'dockeruat') {
  let dockeruat = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-uat-api.afirstsoft.cn/api/v2/',
  };
  envConfig = dockeruat;
}
if (ENVdocker === 'dockerprod') {
  let dockerprod = {
    //cookie顶域
    DOMAIN: window.location.hostname,
    //api
    API_V2_URL: 'https://hitpaw-prod-api.afirstsoft.cn/api/v2/',
  };
  envConfig = dockerprod;
}

export default envConfig;
